// 字符串占位符内容替换
String.prototype._p = function (obj) {
	let str = this
	for (const key in obj) {
		str = str.replace('{' + key + '}', obj[key])
	}
	return str
}

// startsWith兼容实现
if (!''.startsWith) {
	String.prototype.startsWith = function (str) {
		let reg = new RegExp('^' + str);
		return reg.test(this);
	}
}

// endsWith兼容实现
if (!''.endsWith) {
	String.prototype.endsWith = function (str) {
		let reg = new RegExp(str + '$');
		return reg.test(this);
	}
}

// 将中文逗号转化为英文逗号
String.prototype.commaReplace = function () {
	return this.replace(/\uFF0C/g, ',');
}



// WEBPACK FOOTER //
// ./src/util/stringUtil.js